import { render, staticRenderFns } from "./DeleteAccount.vue?vue&type=template&id=c5291e6c&scoped=true&"
import script from "./DeleteAccount.vue?vue&type=script&lang=js&"
export * from "./DeleteAccount.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/mobile/authenticate/_delete-account.scss?vue&type=style&index=0&id=c5291e6c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5291e6c",
  null
  
)

export default component.exports